import {memo, useCallback, useState} from "react"
import {ExtraSmallButton, NonInteractiveTooltip} from "../../custom"
import SettingsOutlinedIcon from "../../../assets/icons/SettingOutlined"
import OptionChainSettingsDialog from "../../../pages/home/fnoHeader/optionsChainSettingsDialog"
import {useStyles} from "./styles"

const OptionChainSettings = ({orderOptionChain = false}: {orderOptionChain?: boolean}) => {
    const [openSettingsAnchorEl, setOpenSettingsAnchorEl] = useState<HTMLElement>()
    const {classes} = useStyles()

    const handleOpenSettings = useCallback((e: any) => {
        setOpenSettingsAnchorEl((v) => (v ? undefined : e.currentTarget))
    }, [])

    return <>
        <NonInteractiveTooltip title="Settings" arrow placement="top">
            <ExtraSmallButton
                data-event={'Settings Clicked'}
                data-event-source={'option-chain-bar'}
                onClick={handleOpenSettings}
                className={classes.item}
                color={"inherit"}
            >
                <SettingsOutlinedIcon fontSize={"small"}/>
            </ExtraSmallButton>
        </NonInteractiveTooltip>
        <OptionChainSettingsDialog orderOptionChain={orderOptionChain} open={openSettingsAnchorEl} setOpen={setOpenSettingsAnchorEl}/>
    </>
}

export default memo(OptionChainSettings)